//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActivityConvertModal",
  components: {
    GenericModal
  },
  props: {
    currentLenderNote: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      modalOpened: false
    };
  },
  methods: {
    handleShow() {
      this.modalOpened = true;
    },
    handleHidden() {
      this.modalOpened = false;
    }
  }
});